import { Navigate, useLocation } from 'react-router';
import PageNotFound from '../common/lib/PageNotFound';
import type { MultiLang } from '../config';

interface Props {
    lang: MultiLang;
    name: string;
}

const getRedirectUrl = (name: string, location: { pathname: string; search: string }): string => {
    {
        const pathname = location.pathname || '';
        const search = new RegExp(`^/modules/${name}(?:/+(.*))?$`);
        const matches = pathname.match(search);
        if (matches === null) {
            return '';
        }
        const path = matches[1] || '';
        switch (path) {
            case '':
            case 'index.php': {
                const params = new URLSearchParams(location.search);
                const paramString = params.toString();
                return `/${name}/${paramString !== '' ? `?${paramString}` : ''}`;
            }
        }
        return `/${name}/${path}`;
    }
};

const PicoXoopsPathRedirect = (props: Props) => {
    const { lang, name } = props;
    const location = useLocation();
    const url = getRedirectUrl(name, location);
    if (url === '') {
        return <PageNotFound lang={lang} />;
    }
    return <Navigate to={url} replace />;
};

export default PicoXoopsPathRedirect;
